import {
  Input,SimpleChanges,OnChanges,
  ViewChild,
  Component,
  OnInit
} from '@angular/core';
import {MatDialog, MatDialogRef, MAT_DIALOG_DATA} from '@angular/material';
import {ServiceItemVM} from "../../models/ServiceItemVM";
import {ServiceItemDetailVM} from "../../models/ServiceItemDetailVM";
import {SessionDateVM} from "../../models/SessionDateVM.model";
import {SessionTimeVM} from "../../models/SessionTimeVM.model";
import {CategoryService} from "../../services/category/category.service";
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {AuthService} from "../../services/auth/AuthService";
import {AuthGuard} from "../../services/auth/AuthGuard";
import {TranslateService} from "ng2-translate";
import {PaymentResultVM,STATUS_CREATED,STATUS_OK} from "../../models/PaymentResultVM.model";
import {OrderBagService} from "../../services/orderbag/orderbag.service";
import {OrderBagVM} from "../../models/OrderBagVM.model";
import {PriceInfoDetailVM} from "../../models/PriceInfoDetailVM.model";
import {AlertService} from "../../services/alert/alert.service";
import {ParticipantVM} from "../../models/ParticipantVM.model";
import {TotalPriceVM} from "../../models/TotalPriceVM.model";
import {OrderBagItemVM} from "../../models/OrderBagItemVM.model";
import {OrderBagItemDetailVM} from "../../models/OrderBagItemVM.model";
import {CompanyService} from "../../services/company-service/company-service";
import {PAYMENT_WEB_URL} from '../../services/constants';
import {Router} from '@angular/router';
import {LoginComponent} from "../../login/login.component";
import * as moment from 'jalali-moment';
import {SelectDateDialog} from "../shared/select-date-dialog/select-date-dialog.component";
import {Data} from "../../../../node_modules/@agm/core/services/google-maps-types";
import {Location} from "@angular/common";
import { PlatformLocation } from '@angular/common'
import * as Moment from 'moment';
import {IntakeFormComponent} from "../intake-form/intake-form.component";
import {IntakeFormVM} from "../../models/IntakeForm.model";

//import {OrderBagItemVM} from "../../models/OrderBagItemVM.model";

@Component({

  selector: 'rw-book-toolbar',  // <home></home>

  styles: [require('./book-toolbar.component.css')],

  template: require('./book-toolbar.component.html')
})
export class BookToolbarComponent implements OnInit,OnChanges {
  public Steps:any[] =
    [
      {stepNumber: 1, title: 'SELECT_DATE', included: false, disabled: true, expanded: false},
      {stepNumber: 1.1, title: 'SELECT_DATE_TIME', included: false, disabled: true, expanded: false},
      {stepNumber: 2, title: 'SELECT_TIME', included: false, disabled: true, expanded: false},
      {stepNumber: 2.1, title: 'SELECT_FROM_TIME', included: false, disabled: true, expanded: false},
      {stepNumber: 2.2, title: 'SELECT_TO_TIME', included: false, disabled: true, expanded: false},
      {stepNumber: 3, title: 'SELECT_QTY', included: false, disabled: true, expanded: false},
      {stepNumber: 4, title: 'GET_PARTICIPANTS', included: false, disabled: true, expanded: false},
      {stepNumber: 5, title: 'SELECT_OPTIONS', included: false, disabled: true, expanded: false},
      {stepNumber: 5.1, title: 'SELECT_MULTIPLE_DATE', included: false, disabled: true, expanded: false},
      {stepNumber: 5.2, title: 'AUTO_MULTIPLE_DATE', included: false, disabled: true, expanded: false},
      {stepNumber: 5.3, title: 'INTAKE_FORM', included: false, disabled: true, expanded: false},

      {stepNumber: 6, title: 'CONFIRM', included: true, disabled: true, expanded: false}

    ];
  public currentStep:any;
   private NOT_ALLOWED_MULTIPLE_TIME_TYPE='DAILY';

  @Input() public serviceItemDetail:ServiceItemDetailVM;
  @Input() public activePrice:any;
  public sessionDates:SessionDateVM[] = [];
  public activeDays:Array<Date>;
  public busy;
  public busy_to_compute_priceInfo_list;
  public busy_to_compute_price;
  public busy_to_fill_times;
  public orderBagComment:string = '';
  public sessionTimes:SessionTimeVM[] = [];
  public sessionTimesAM:SessionTimeVM[] = [];
  public sessionTimesPM:SessionTimeVM[] = [];
  public endSessionTimesAM:SessionTimeVM[] = [];
  public endSessionTimesPM:SessionTimeVM[] = [];
  public toSessionTimes:SessionTimeVM[] = [];
  public qtyOptions:number[] = [];
  public priceInfos:PriceInfoDetailVM[] = [];
  public selectedDate:Date;
  public selectedTime:SessionTimeVM = new SessionTimeVM();
  public toSelectedTime:SessionTimeVM = new SessionTimeVM();
  public showCalendar:boolean = false;
  public baseurl;
  public canAddToCard:boolean = false;
  public fromDateMessage:String;
  public fromTimeMessage:String;
  public toTimeMessage:String;
  public orderBag:OrderBagVM;
  public totalPrice:OrderBagVM;
  public bookWasSuccessful:boolean = false;
  public userCanHaveInplacePayment = false;
  public userShouldPay = false;
  public bookComment:string = '';
  public orderBagItem:OrderBagItemVM;
  public isInstantBooking = true;
  public isFloatSchedule = false;
  public isMulipleTime=false;
  public isMultipleDate = false;
  public availableCapacity:number = 0;
  public qty_unit:string = 'نفر';
  public loading:boolean = false;
  public canSelectMultipleDates:boolean = false;
  public isAutoSelectMultipleDates:boolean = false;
  public isAllAutoDatesAreFilled:boolean = false;
  public newMultipleDate:Date;
  public hasIntakeForm:boolean = false;
  public showPrePayment:boolean=false;
  public notTimeAvailable:boolean=false;
  public maxQty:number;
  public priceInfoComputed=false;

  @ViewChild(IntakeFormComponent) intakeFormComponent:IntakeFormComponent;

  constructor(private location:PlatformLocation, private authService:AuthService,
              public dialog:MatDialog,
              private router:Router, private companyService:CompanyService, private categoryService:CategoryService, private orderBagService:OrderBagService, private authGuard:AuthGuard,
              private translate:TranslateService, private _formBuilder:FormBuilder, private alertService:AlertService) {
  }

  public ngOnInit() {
    //  this.currentStep = this.Steps[0];
    this.initSteps();
    this.checkIfUserCanPayInPlace();
    //this.location.onPopState(() => {
    //
    //this.gotoPrevStep()
    //    return false;
    //});
  }

  initSteps() {
    this.Steps.forEach((s)=> {
      s.ptitle = this.getStepTitle(s.stepNumber);
    })

  }

  refreshSteps() {
    let parent = this;
    parent.Steps.forEach((s)=> {
      s.disabled = this.isStepDisabled(s.stepNumber);
      s.expanded = this.isStepExpanded(s.stepNumber);
    })
  }

  ngOnChanges(changes:SimpleChanges):void {
    let parent = this;

    this.initOrderBagItem();
    if (this.serviceItemDetail) {
      if (this.serviceItemDetail.multiReserveMode === "MANUAL")
        this.canSelectMultipleDates = true;
      if (this.serviceItemDetail.multiReserveMode === "AUTO") {
        this.isAutoSelectMultipleDates = true;

      }
      if (this.serviceItemDetail.confirmationType == 'TWO_STEP')
        this.isInstantBooking = false;
      if (this.serviceItemDetail.scheduleInfo && this.serviceItemDetail.scheduleInfo.scheduleType == 'FLOAT_TIME_SESSIONS') {


        parent.isFloatSchedule = true;
        parent.isMulipleTime=true;
        if(this.serviceItemDetail.consecutiveReserveMode=='DISABLE')
        {
          parent.isMulipleTime=false;
        }
      }

      let qu = this.categoryService.getServiceCustomSetting(this.serviceItemDetail, 'qty_unit');
      parent.maxQty= this.categoryService.getServiceCustomSetting(this.serviceItemDetail, 'max_qty');

      if (qu) {
        this.qty_unit = qu;

      }
      if (this.serviceItemDetail.intakeForm && this.serviceItemDetail.intakeForm.fields && this.serviceItemDetail.intakeForm.fields.length > 0)
        this.hasIntakeForm = true;
      this.fillOptions();
      this.includeSteps();
      this.refreshSteps();
      this.fillDates();

    }


  }

  setStep(index:number) {

    if (!this.Steps[index].disabled) {
      this.currentStep = this.Steps[index];
      this.refreshSteps();
    }


  }

  isStepDisabled(index:number) {
    return (this.getStepByStepNumber(index).stepNumber > this.currentStep.stepNumber);
  }

  isStepExpanded(index:number) {
    return (this.getStepByStepNumber(index).stepNumber == this.currentStep.stepNumber);
  }

  getStepTitle(index:number) {
    let key = 'book.steps.' + this.getStepByStepNumber(index).title;
    return key;
  }

  getStepByStepNumber(index:number) {
    let steps = this.Steps.filter((s)=> {
      return s.stepNumber == index
    });
    if (steps && steps.length > 0)
      return steps[0];

  }

  setFirstStep() {
    let parent = this;
    let found = false;
    this.Steps.forEach((s)=> {
      if (!found && (0 < s.stepNumber && s.included )) {
        parent.currentStep = s;
        found = true;
      }
    });
    parent.currentStep.disabled = false;
    parent.currentStep.expanded = true;

  }

  nextStep() {

    let parent = this;
    let found = false;
    parent.Steps.forEach((s)=> {
      if (!found && (parent.currentStep.stepNumber < s.stepNumber && s.included )) {
        parent.currentStep = s;
        found = true;
      }
    });
    parent.refreshSteps();


    if (parent.currentStep.title == 'CONFIRM')
      parent.onFinalStep();
    if (parent.currentStep.title == 'SELECT_MULTIPLE_DATE')
      parent.doBeforeMultipleDateStep();
    if (parent.currentStep.title == 'AUTO_MULTIPLE_DATE')
      parent.doBeforeMultipleDateStep();

  }

  gotoPrevStep() {

    //   if(this.currentStep.stepNumber==1)return true;

    //  if(this.currentStep.stepNumber==2)
    this.setStep(0);
    return false;
  }

  doBeforeMultipleDateStep() {

    this.clearExtraOrderBagItems();
    this.fillOrderBagObject();
    if (this.isAutoSelectMultipleDates) {
      this.AddDaysAutomatic();
    }

  }

  confirmMultiDateSelect() {
    let parent = this;
    setTimeout(function () {
      parent.nextStep();
    }, 1)
  }


  confirmQty() {
    let parent = this;
    let totalQty = this.getTotalQty();
    if (totalQty > 0) {
      if (totalQty <= this.availableCapacity) {
        parent.makeParticipantList();
        setTimeout(function () {
          parent.nextStep();
        }, 1);
      }
      else {

        parent.alertService.showErrorMessage("برای هر نوبت حداکثر" + this.availableCapacity + " نفر قابل رزرو است");
      }
    }
    else {
      parent.alertService.showErrorMessage("تعداد رزرو را انتخاب کنید");
    }

  }

  confirmParticipant() {
    let parent = this;
    setTimeout(function () {
      parent.nextStep();
    }, 1)

  }

  confirmOptions() {


    let parent = this;
    setTimeout(function () {
      parent.nextStep();
    }, 1);

  }

  includeSteps() {

    this.Steps.forEach((step)=> {
      switch (step.title) {
        case 'SELECT_DATE':
          if (!this.isMultipleDate)
            step.included = true;
          break;
        case 'SELECT_FROM_TIME':
          if (this.isFloatSchedule )
            step.included = true;
          break;
        case 'SELECT_TO_TIME':
          if (this.isFloatSchedule && this.isMulipleTime)
            step.included = true;
          break;
        case 'SELECT_TIME':
          if (!this.isMultipleDate && !this.isFloatSchedule)
            step.included = true;
          break;
        case 'SELECT_DATE_TIME':
          if (this.isMultipleDate)
            step.included = true;

          break;
        case 'SELECT_QTY':
          if (this.serviceItemDetail.capacityInfo && this.serviceItemDetail.capacityInfo.qty > 1) {
            step.included = true;

          }
          if(this.maxQty )
          {
            this.serviceItemDetail.capacityInfo.qty=this.maxQty;
            if(this.maxQty==1)
            {
              step.included = false;
            }
          }
          if (this.serviceItemDetail.priceInfoDtails && this.serviceItemDetail.priceInfoDtails.length > 1) {
            step.included = true;
          }
          break;
        case 'GET_PARTICIPANTS':
          if (this.serviceItemDetail.mustGetParticipantInfo)
            step.included = true;


          break;

        case 'SELECT_OPTIONS':

          if (this.orderBagItem.options && this.orderBagItem.options.length > 0)
            step.included = true;
          break;
        case 'SELECT_MULTIPLE_DATE':


          if (this.canSelectMultipleDates)
            step.included = true;

          break;

        case 'AUTO_MULTIPLE_DATE':
          if (this.isAutoSelectMultipleDates)
            step.included = true;

          break;
        case 'INTAKE_FORM':
          if (this.hasIntakeForm)
            step.included = true;

          break;

      }


    })
    this.setFirstStep();
  }

  makeParticipantList() {
    let parent = this;
    parent.orderBagItem.participantPersons = [];
    for (let i = 0; i < this.getTotalQty(); i++) {
      parent.orderBagItem.participantPersons.push(new ParticipantVM());
    }


  }

  fillPriceInfos() {

    let parent = this;
    parent.loading = true;
    if (this.isFloatSchedule) {
      this.busy_to_compute_priceInfo_list = this.orderBagService.
      getPriceInfoDetailByServiceIdAndStartDate(this.serviceItemDetail.id, this.selectedTime.startTime).
      subscribe(function (prices) {

        parent.orderBagItem.orderBagServiceItemDtail = [];
        if (prices) {
          prices.forEach((priceInfo)=> {
            let orderBagServiceItemDtail = new OrderBagItemDetailVM();
            orderBagServiceItemDtail.priceInfoDtail = priceInfo;
            parent.orderBagItem.orderBagServiceItemDtail.push(orderBagServiceItemDtail)
          })
        }
        if (parent.orderBagItem.orderBagServiceItemDtail.length == 1)
          parent.orderBagItem.orderBagServiceItemDtail[0].gty = 1;
        parent.calculateMaxAvailableCapacity();
        parent.nextStep();
        parent.loading = false;
      });
    } else {
      this.busy_to_compute_priceInfo_list = this.orderBagService.
      getPriceInfoDetailByServiceIdAndTimeSession(this.serviceItemDetail.id, this.selectedTime.id).
      subscribe(function (prices) {
        parent.loading = false;
        parent.orderBagItem.orderBagServiceItemDtail = [];
        if (prices) {
          prices.forEach((priceInfo)=> {
            let orderBagServiceItemDtail = new OrderBagItemDetailVM();
            orderBagServiceItemDtail.priceInfoDtail = priceInfo;
            parent.orderBagItem.orderBagServiceItemDtail.push(orderBagServiceItemDtail)
          })
        }
        if (parent.orderBagItem.orderBagServiceItemDtail.length == 1)
          parent.orderBagItem.orderBagServiceItemDtail[0].gty = 1;
        parent.calculateMaxAvailableCapacity();

        parent.nextStep();
      });
    }
  }

  fillQtyOptions(maxCapacity) {
    this.qtyOptions = [];
    for (let i = 1; i <= maxCapacity; i++)
      this.qtyOptions.push(i);
  }

  fillOptions() {
    let parent = this;
    parent.orderBagService.getServiceItemOptionsByServiceItemid(parent.serviceItemDetail.id).subscribe(function (options) {
      parent.orderBagItem.options = options;
      parent.includeSteps();
    });
  }

  getQtyOptions(priceInfo) {
    let selectableList:number[] = [];


    for (let i = 1; i <= this.availableCapacity; i++) {
      selectableList.push(i);
    }


    return selectableList;
  }

  calculateMaxAvailableCapacity() {
    let parent = this;
    let selectableList:number[] = [];
    if (!this.isFloatSchedule) {
      if (this.selectedTime && this.selectedTime.capacity) {
        this.availableCapacity = this.selectedTime.capacity;
      }
    } else {
      let timeSpan:SessionTimeVM = new SessionTimeVM();
      timeSpan.startTime = this.selectedTime.startTime;
      timeSpan.endTime = this.toSelectedTime.endTime;
      timeSpan.serviceItemId = this.serviceItemDetail.id;
      this.orderBagService.getAvailableCapacity(timeSpan).subscribe((ts)=> {
        parent.availableCapacity = ts.capacity;

      })
    }
    return selectableList;
  }

  getTotalQty() {

    let totalqty:number = 0;
    if (this.orderBagItem && this.orderBagItem.orderBagServiceItemDtail) {
      this.orderBagItem.orderBagServiceItemDtail.forEach((pi)=> {
        if (pi.priceInfoDtail) {
          pi.priceInfoDtailId = pi.priceInfoDtail.id;
        }
        if (pi.gty && pi.gty > 0)
          totalqty += pi.gty;
        else
          totalqty += 0;
      })
    }
    return totalqty;
  }

  addDays(date, days:number) {
    var result = new Date(date);
    result.setDate(result.getDate() + days);
    return result;
  }

  fillDates() {
    let from = new Date();
    let to = new Date();
    to = this.addDays(to, 90);

    let parent = this;
    this.categoryService.getServiceSessionDatesByServiceid(this.serviceItemDetail.id, from, to).subscribe(sd=> {
      this.sessionDates = sd;
      this.activeDays = [];

      this.sessionDates.forEach((sd)=> {
        this.activeDays.push(new Date(sd.startDate.toString()));
      });
      if (this.activeDays.length > 0) {
        parent.showCalendar = true;
        // this.selectedDate = this.sessionDates[0].startDate;
        this.fillTimes();
      }

    }, error=> {
    });
  }

  selectedDateChanged(event) {
    if (event) {
      this.selectedDate = event;
      this.fillTimes();

    }
  }

  selectedMultipleDate(event) {

  }

  onFinalStep() {
    this.computeOrderbagPrice();
  }

  onFromTimeChanged(e) {

    let parent = this;
    this.selectedTime = e;
    this.toSelectedTime = null;
    if (e) {
      this.toSessionTimes = this.sessionTimes.filter((st)=> {
        return st.startTime >= e.startTime;
      });

    }
  }

  onToTimeChanged(e) {
    this.toSelectedTime = e;
    //   this.computeOrderbagPrice();
  }

  confirmDateAndTime() {
    let isValid = this.validateBookingTimeStep();
    if (isValid) {
      if (this.authService.isAuthenticated) {

        this.changeStep(1);
      } else {
        this.authGuard.openLoginDialog();
      }
    }
  }

  fillTimes() {
    let parent = this;
    if (this.serviceItemDetail && this.selectedDate) {

      this.selectedDate = new Date(this.selectedDate.toString());
      parent.loading = true;
      parent.busy_to_fill_times = this.categoryService.getServiceSessionTimesByServiceid(this.serviceItemDetail.id, this.selectedDate).subscribe(sd=> {

        this.sessionTimes = sd;
        this.splitSessionTimes(this.sessionTimes);
        parent.notTimeAvailable=true;
        this.sessionTimes.forEach(function(t){
          if(t.capacity>0 && !parent.isExpired(t.startTime))
            parent.notTimeAvailable=false;
        })
        parent.loading = false;
        this.nextStep();
        this.toSessionTimes = [];
      }, error=> {
       parent.alertService.showErrorMessage(error);
        parent.loading = false;
      });


    }
    else {
      this.sessionTimes = [];
      this.toSessionTimes = [];
    }
  }

  fillEndTimes() {
    let parent = this;
    let filteredEndTimes = [];
    let maxEvailableTime = parent.selectedTime;
    let nextNotAvailableTimeFound = false;

    this.sessionTimes.forEach(t=> {
      let mTime = moment(new Date(t.endTime));
      let mselectedTime = moment(new Date(parent.selectedTime.startTime));
      if (!nextNotAvailableTimeFound && mTime.isAfter(mselectedTime)) {
        if (t.capacity > 0) {
          maxEvailableTime = t;
        } else {
          nextNotAvailableTimeFound = true;
        }
      }
    });

    this.sessionTimes.forEach(t=> {
      let tcopy = JSON.parse(JSON.stringify(t))
      let mTime = moment(new Date(t.endTime));
      let mselectedTime = moment(new Date(parent.selectedTime.startTime));
      tcopy.disabled = !(t.capacity > 0);
      if (mTime.isSameOrBefore(mselectedTime) || mTime.isAfter(maxEvailableTime.endTime))
        tcopy.disabled = true;

      filteredEndTimes.push(tcopy);
    })

    this.splitEndSessionTimes(filteredEndTimes);
  }

  initOrderBagItem() {
    this.orderBag = new OrderBagVM();

    this.orderBagItem = new OrderBagItemVM();
    this.orderBagItem.serviceItem = new ServiceItemVM();
    this.orderBagItem.orderBagServiceItemDtail = [];
    this.orderBagItem.options = [];
    this.orderBagItem.totalPrice = new TotalPriceVM();
    this.orderBagItem.participantPersons = [];
    this.orderBagItem.timeSession = new SessionTimeVM();
    this.orderBag.orderBagServiceItems.push(this.orderBagItem);
  }

  splitSessionTimes(times) {
    let parent = this;
    if (times) {
      parent.sessionTimesAM = []
      parent.sessionTimesPM = []
      times.forEach((t)=> {

        if (t.capacity <= 0)
          t.disabled = true;
        let st = new Date(t.startTime);
        if (st.getHours() < 12)
          parent.sessionTimesAM.push(t);
        else
          parent.sessionTimesPM.push(t);

      })
    }
  }

  splitEndSessionTimes(times) {
    let parent = this;
    if (times) {
      parent.endSessionTimesAM = [];
      parent.endSessionTimesPM = [];
      times.forEach((t)=> {

        if (t.capacity > 0) {
          let st = new Date(t.endTime);
          if (st.getHours() < 12)
            parent.endSessionTimesAM.push(t);
          else
            parent.endSessionTimesPM.push(t);
        }
      })
    }
  }

  changeStep(index:number) {
    // this.bookingStepper.next();

  }

  resetMessage() {
    this.fromDateMessage = '';
    this.fromTimeMessage = '';
    this.toTimeMessage = '';
  }

  selectTime(select) {
    this.selectedTime = select;

    this.fillPriceInfos();


  }

  selectStartTime(select) {
    let parent = this;
    parent.selectedTime = select;
    if(this.isMulipleTime) {
      this.fillEndTimes();
      setTimeout(function () {
        parent.nextStep();
      }, 10);
    }else
    {
      this.toSelectedTime = select;
      this.fillPriceInfos();
    }


  }

  selectEndTime(select) {
    this.toSelectedTime = select;
    this.fillPriceInfos();
  }

  public validateBookingTimeStep():boolean {
    this.resetMessage();
    let isValid = true;
    if (!this.selectedDate) {
      isValid = false;
      this.fromDateMessage = this.translate.instant("vmsg.fromDateIsRequired");
    }
    if (!this.selectedTime.startTime) {
      isValid = false;
      this.fromTimeMessage = this.translate.instant("vmsg.fromTimeIsRequired");
    }
    if (!this.toSelectedTime.startTime) {
      isValid = false;
      this.toTimeMessage = this.translate.instant("vmsg.toTimeIsRequired");
    }

    return isValid;
  }

  toSTR(jo:any) {
    return JSON.stringify(jo);
  }

  confirmOrderBagThen(res:PaymentResultVM) {
    if (res.status == STATUS_CREATED || res.status == STATUS_OK) {
      this.bookWasSuccessful = true;

      this.gotoPayment(res);
    }
    else {
    }


  }

  confirmIntakeForm() {
    let parent = this;

    if (this.intakeFormComponent) {
      if (this.intakeFormComponent.collectFormData()) {
        setTimeout(function () {
          parent.nextStep();
        }, 1)
      }
    }
  }

  confirmOrderBagInplacePayment() {

    this.confirmOrderBagByInplace(true);
  }

  confirmOrderBagByInplace(isInplacePayment:boolean) {

    // this.makeOrderBagObject();
    this.orderBagService.confirmOrderBag(this.orderBag).then((res)=> {

      this.confirmOrderBagThen(<PaymentResultVM>res)
    }).catch((er)=> {
      this.bookWasSuccessful = false;
      this.setStep(0);
    });

  }

  checkIfUserCanPayInPlace() {
    let parent = this;
    parent.companyService.getCompanyInfo().subscribe((company)=> {
      parent.userCanHaveInplacePayment = company.inPlacePayment
      //parent.orderBagService.userCanPayInplace(company.id).subscribe((can)=>{
      //  if(can)
      //    parent.userCanHaveInplacePayment=true;
      //  else
      //    parent.userCanHaveInplacePayment=false;
      //})
    });

  }

  confirmOrderBag() {
    let parent = this;
    if (this.authService.isAuthenticated) {
      parent.loading = true;
      this.busy = this.orderBagService.confirmOrderBag(this.orderBag).then((res)=> {
        this.confirmOrderBagThen(<PaymentResultVM>res)
        parent.loading = false;
      }).catch((er)=> {

        this.bookWasSuccessful = false;
        parent.loading = false;
        parent.setStep(0);
        parent.alertService.showErrorMessage(er);

      });
    }
    else {
      this.openLoginDialog();
    }

  }

  openLoginDialog():void {
    let parent=this;
    this.authGuard.openLoginDialog(function(){

      setTimeout(function(){
        if (parent.authService.isAuthenticated) {
          parent.alertService.showInfoMessage('جهت ثبت رزرو بر روی دکمه تایید کلیک کنید');
        }else
        {
          parent.alertService.showErrorMessage('برای ثبت رزرو لازم است ثبت نام کنید. اگر قبلا ثبت نام کرده اید وارد شوید');
        }
      }
    ,2000)
    });
    //let dialogRef = this.dialog.open(LoginComponent, {
    //  width: '600px',
    //  data: {name: 'saeed'}
    //});
  }

  confirmAndPayOnline() {

    this.confirmOrderBag();
  }

  confirmAndPayInPlace() {
    this.orderBag.inPlacePayment = true;
    this.confirmOrderBag();
  }

  computeOrderbagPrice() {
    let parent = this;
    parent.fillOrderBagObject();
    // this.makeOrderBagObject();

    parent.loading = true;
    parent.priceInfoComputed=false;
    this.busy_to_compute_price = this.orderBagService.computeOrderbagPrice(this.orderBag).subscribe((tp)=> {
      parent.loading = false;
      parent.priceInfoComputed=true;
      parent.totalPrice = tp;
      if (parent.totalPrice.onlinePaymentAmount > 0)
        parent.userShouldPay = true;
      else
        parent.userShouldPay = false;

      if(parent.totalPrice.onlinePaymentAmount<this.totalPrice.finalPrice)
        parent.showPrePayment=true
      else
        parent.showPrePayment=false;
      //
    });
  }


  public gotoPayment(res:PaymentResultVM):void {
    if (res.free || res.twoStepBooking || this.orderBag.inPlacePayment) {

      this.router.navigateByUrl('/booked?id=' + res.orderBagId);
    }
    else if (res.authority) {
      window.location.href = PAYMENT_WEB_URL + res.authority;
    }

  }

  private clearExtraOrderBagItems() {
    let primeItem = this.orderBag.orderBagServiceItems[0];
    this.orderBag.orderBagServiceItems = [];
    this.orderBag.orderBagServiceItems.push(primeItem);
  }

  private fillOrderBagObject():void {
    let parent = this;
    // this.orderBag.comment=this.bookComment;
    this.orderBagItem.serviceItemId = this.serviceItemDetail.id;
    this.orderBagItem.serviceItem = this.serviceItemDetail;
    if (this.hasIntakeForm) {
      this.orderBag.intakeData = '';
      let formData:any = {};
      formData.fields = [];
      let fields = this.serviceItemDetail.intakeForm.fields;
      fields.forEach(function (f) {
        formData.fields.push({name: f.name, label: f.label, value: f.value})
      })
      this.orderBag.intakeData = formData;
    }
    if (!this.isFloatSchedule) {
      this.orderBagItem.timeSession = this.selectedTime;
    }
    else {
      let timeSession = new SessionTimeVM();
      timeSession.startDate = this.selectedDate;
      timeSession.endDate = this.selectedDate;
      timeSession.startTime = this.selectedTime.startTime;
      //timeSession.endTime = this.selectedTime.endTime;
      //
      //if(this.isMulipleTime)
      timeSession.endTime = this.toSelectedTime.endTime;
      this.orderBagItem.timeSession = timeSession;
    }
  }

  private makeOrderBagObject():void {
    this.orderBag = new OrderBagVM();
    this.orderBag.orderBagServiceItems = [];
    // this.orderBag.comment = this.bookComment;
    let orderBagItem:OrderBagItemVM = new OrderBagItemVM();
    orderBagItem.serviceItemId = this.serviceItemDetail.id;
    orderBagItem.orderBagServiceItemDtail = [];
    this.activePrice.gty = 1;
    this.activePrice.priceInfoDtailId = this.activePrice.id;
    this.activePrice.timeUnitQty = this.getUnitQty();
    orderBagItem.serviceItem = this.serviceItemDetail;

    orderBagItem.orderBagServiceItemDtail.push(this.activePrice);
    let timeSession:SessionTimeVM = new SessionTimeVM();
    timeSession.startTime = this.selectedTime.startTime;
    timeSession.endTime = this.toSelectedTime.endTime;
    timeSession.startDate = this.selectedDate;
    timeSession.endDate = this.selectedDate;
    orderBagItem.timeSession = timeSession;
    this.orderBag.orderBagServiceItems.push(orderBagItem);

  }

  getUnitQty() {
    if (this.serviceItemDetail.scheduleInfo && this.serviceItemDetail.scheduleInfo.floatingTimeType == 'HOURLY') {
      let selected_duration = this.computeDurationInMinutes(this.selectedTime.startTime, this.toSelectedTime.endTime);
      // let durationUnit=this.computeDurationInMinutes(this.selectedTime.startTime,this.selectedTime.endTime);
      let unitQty = Math.round((selected_duration / 60) * 100) / 100;
      return unitQty;
    }

  }

  private editDateAndTime() {
    this.changeStep(0);
  }

  private editInformation() {
    this.changeStep(1);
  }

  private finalConfirmation() {
    this.confirmOrderBagByInplace(false);
  }

  removeMultipleDate(item:OrderBagItemVM) {

    var index = this.orderBag.orderBagServiceItems.indexOf(item, 0);
    if (index > -1) {
      this.orderBag.orderBagServiceItems.splice(index, 1);
    }
  }

  openDialog():void {
    let parent = this;
    let dialogRef = this.dialog.open(SelectDateDialog, {

      data: {
        activeDays: this.activeDays,
        selectedDate: this.newMultipleDate
      }
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result)
        this.addNewDateToOrderBagItem(result);

    });

  }

  private computeDurationInMinutes(startTime:Date, endTime:Date):number {
    if (startTime && endTime) {
      startTime = new Date(startTime.toString());
      endTime = new Date(endTime.toString());
      return ((endTime.getHours() - startTime.getHours()) * 60) + (endTime.getMinutes() - startTime.getMinutes());
    } else {
      return 0;
    }
  }

  private AddDaysAutomatic() {
    this.isAllAutoDatesAreFilled = true;
    let extraRepeat:number = 0;
    let filledDatesCount:number = 0;
    let primeItem:OrderBagItemVM = this.orderBag.orderBagServiceItems[0];
    if (this.serviceItemDetail.multiReserveConfig && this.serviceItemDetail.multiReserveConfig.repeatCount) {
      extraRepeat = this.serviceItemDetail.multiReserveConfig.repeatCount - 1;
    }
    if (extraRepeat > 0) {
      let nextDateOffset = 1;
      let isDayMode = (this.serviceItemDetail.multiReserveConfig.repeatMode == 'DAY_PERIOD');
      if (!isDayMode)//it is weekly
        nextDateOffset = 7;

      let baseDate = primeItem.timeSession.startDate;
      let mTime = Moment(new Date(baseDate));

      let i = 0;
      let repeatedDateList:Date[] = [];
      while (filledDatesCount < extraRepeat && i < 100) {

        mTime = mTime.add(nextDateOffset, 'days');
        if (this.isSelectedDateInAvailableDate(mTime)) {

          this.addNewDateToOrderBagItem(mTime.toDate());
          filledDatesCount++;
        }
        i++;
      }
      if (filledDatesCount < extraRepeat)
        this.isAllAutoDatesAreFilled = false;

    }

  }

  private addNewDateToOrderBagItem(result:any):void {


    let primeItem = this.orderBag.orderBagServiceItems[0];
    let newItem = JSON.parse(JSON.stringify(primeItem));
    newItem.timeSession.startDate = result;

    this.setTimeForNewDate(primeItem, newItem, newItem.timeSession.startDate)

  }

  setTimeForNewDate(currentItem, newItem, newDate) {
    let parent = this;
    if (this.serviceItemDetail && newDate) {
      parent.loading = true;
      parent.busy_to_fill_times = this.categoryService.getServiceSessionTimesByServiceid(this.serviceItemDetail.id, newDate).subscribe(sd=> {


        let isAvailable = parent.isDateAvailable(sd, currentItem);
        if (isAvailable) {
          if (!this.isFloatSchedule) {
            //finding timesessionid
            sd.forEach(function (time) {
              if (parent.compareTimePart(time.startTime, currentItem.timeSession.startTime) == 0) {
                newItem.timeSession.id = time.id;
                newItem.timeSession.startDate = time.startTime;
                newItem.timeSession.endDate = time.endTime;
                newItem.timeSession.startTime = time.startTime;
                newItem.timeSession.endTime = time.endTime;
              }
            })
          }
          else {
            newItem.timeSession.startDate = newDate;
            newItem.timeSession.endDate = newDate;
            newItem.timeSession.startTime = this.concatTimeAndDate(currentItem.timeSession.startTime, newDate);
            newItem.timeSession.endTime = this.concatTimeAndDate(currentItem.timeSession.endTime, newDate);
          }

          if (this.compareDatePart(newItem.timeSession.startDate, currentItem.timeSession.startDate) != 0)
            this.orderBag.orderBagServiceItems.push(newItem);
        }
        else {
          if (this.isAutoSelectMultipleDates) {
            this.isAllAutoDatesAreFilled = false;
          }
          else {
            this.alertService.showErrorMessage('error.reserveTimeIsnotAvailableInGivenDate');
          }
        }

        parent.loading = false;

        this.toSessionTimes = [];
      }, error=> {
        parent.loading = false;
      });


    }
  }

  isDateAvailable(avTimes:SessionTimeVM[], currentItem:any):boolean {
    let parent = this;
    let totalQty = parent.getTotalQty();
    let isAvailable = true;
    avTimes.forEach(function (time) {
      if (parent.hasTimeConflict(currentItem.timeSession, time)) {
        if (totalQty > time.capacity || time.disabled)
          isAvailable = false;
      }
    })
    return isAvailable;


  }

  hasTimeConflict(timeSession:SessionTimeVM, time:SessionTimeVM):any {
    let start1 = timeSession.startTime;
    let end1 = timeSession.endTime;
    let start2 = time.startTime;
    let end2 = time.endTime;

    if (this.isTimeInPeriod(start1, start2, end2) || this.isTimeInPeriod(start2, start1, end1)) {
      return true;
    }
    return false;
  }

  private isTimeInPeriod(start1:Date, start2:Date, end2:Date):any {
    let parent = this;
    return (parent.compareTimePart(start1, start2) >= 0 && parent.compareTimePart(start1, end2) < 0 )
  }

  private compareTimePart(start1:Date, start2:Date) {
    start1 = new Date(start1.toString())
    start2 = new Date(start2.toString())
    let timeInMin1 = start1.getHours() * 60 + start1.getMinutes();
    let timeInMin2 = start2.getHours() * 60 + start2.getMinutes();

    if (timeInMin1 > timeInMin2)return 1;
    if (timeInMin1 < timeInMin2)return -1;
    if (timeInMin1 == timeInMin2)return 0;


  }

  private compareDatePart(start1:Date, start2:Date) {
    start1 = new Date(start1.toString())
    start2 = new Date(start2.toString())

    start1.setHours(0, 0, 0, 0);
    start2.setHours(0, 0, 0, 0);

    if (start1.valueOf() === start2.valueOf())return 0;
    if (start1.valueOf() > start2.valueOf())return 1;
    if (start1.valueOf() < start2.valueOf())return -1;


  }

  concatTimeAndDate(time:Date, date:Date) {
    if (time && date) {

      let retDateTime = new Date(time);
      retDateTime.setFullYear(date.getFullYear());
      retDateTime.setMonth(date.getMonth());
      retDateTime.setDate(date.getDate());
      return retDateTime;
    }
    else {
      return time;
    }
  }

  private isSelectedDateInAvailableDate(mTime):any {
    let exists = false;
    this.activeDays.forEach(function (d) {
      let secondMoment = moment(new Date(d));
      if (mTime.startOf('day').isSame(secondMoment.startOf('day')))
        exists = true;
    });

    return exists;
  }
  isExpired(date) {
    try {
      let mTime = moment(new Date(date));
      let now = moment(new Date());
      return (mTime.isBefore())
    }catch(ex)
    {
      return false;
    }

  }
}




// WEBPACK FOOTER //
// node_modules/ngc-webpack??ref--0-2!./node_modules/angular2-template-loader!./src/app/component/book-toolbar/book-toolbar.component.ts